import React, { useEffect, useState } from "react";
import "./StationDashboard.css";
import profilePic from "../images/profile-edit.png";
import settingsIcon from "../images/settings.svg";
import * as signalR from "@microsoft/signalr";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import alertFile from "../sound/alert.wav";
import { useNavigate } from "react-router-dom";



const alertSound = new Audio(alertFile);

const StationDashboard = () => {
  const [alerts, setAlerts] = useState([]);
  const [selectedPatrol, setSelectedPatrol] = useState("");
  const [message, setMessage] = useState("");
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [showWaypointModal, setShowWaypointModal] = useState(false);
  const [waypoints, setWaypoints] = useState([{ latitude: "", longitude: "", height: "" }]);
  const [assignOpen, setAssignOpen] = useState(false);
  const [patrols, setPatrols] = useState([]);
  const [selectedPatrolName, setSelectedPatrolName] = useState("");
const [connection, setConnection] = useState(null);

  const navigate = useNavigate();

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAFXkcBgPlixPN43xgMC1Bx9eY2k2HpyVQ",
  });

  useEffect(() => {
  // Fetch recent alerts
  fetch("https://senu-app.azurewebsites.net/api/alerts/recent")
    .then((res) => {
      if (!res.ok) throw new Error("Failed to fetch alerts: " + res.status);
      return res.json();
    })
    .then((data) => setAlerts(data))
    .catch((err) => console.error(err));

  // Connect to SignalR
  const connection = new signalR.HubConnectionBuilder()
    .withUrl("https://senu-app.azurewebsites.net/alerthub")
    .withAutomaticReconnect()
    .build();

  connection
    .start()
    .then(() => console.log("✅ Connected to SignalR hub"))
    .catch((err) => console.error(err));

  // Single unified listener (backend always calls ReceiveAlert)
  connection.on("ReceiveAlert", (alert) => {
    alertSound.play().catch((e) => console.warn("🔇 Sound error: ", e));
    setAlerts((prev) => [alert, ...prev]);
  });

  return () => connection.stop();
}, []);


  // Waypoints functions
  const handleAddWaypoint = () => setWaypoints([...waypoints, { latitude: "", longitude: "", height: "" }]);
  const handleWaypointChange = (index, field, value) => {
    const newWaypoints = [...waypoints];
    newWaypoints[index][field] = value;
    setWaypoints(newWaypoints);
  };
  const handleConfirmMission = () => navigate("/waypoint-loading", { state: { waypoints } });

  // Contact Patrol
  const handleContactPatrol = () => {
    if (!selectedPatrol || !message) return alert("Select a patrol and enter a message.");
    alert(`Message sent to ${selectedPatrol}: ${message}`);
    setMessage("");
  };

  return (
    <div className="station-container">
      {/* Top Bar */}
      <div className="station-top-bar">
        <div className="station-welcome">
          <img src={profilePic} alt="Profile" className="station-profile-pic" />
          <div className="station-welcome-text">Welcome, Station Admin</div>
        </div>
        <img src={settingsIcon} alt="Settings" className="settings-icon" />
      </div>

      <div className="station-center">
        {/* Send Drone Button */}
        <button className="send-drone-btn" onClick={() => setShowWaypointModal(true)}>
        
        </button>

        {/* Waypoint Modal */}
        {showWaypointModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1100,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                width: "90%",
                maxWidth: "500px",
                padding: "20px",
                position: "relative",
                boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                maxHeight: "80vh",
                overflowY: "auto",
              }}
            >
              <button
                onClick={() => setShowWaypointModal(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                ✖
              </button>

              <h3 style={{ textAlign: "center", marginTop: "0" }}>Waypoint Mission</h3>

              {waypoints.map((wp, index) => (
                <div
                  key={index}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                    padding: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <h4>Waypoint {index + 1}</h4>
                  <input
                    type="number"
                    placeholder="Latitude"
                    value={wp.latitude}
                    onChange={(e) => handleWaypointChange(index, "latitude", e.target.value)}
                    style={{ width: "100%", marginBottom: "5px", padding: "5px" }}
                  />
                  <input
                    type="number"
                    placeholder="Longitude"
                    value={wp.longitude}
                    onChange={(e) => handleWaypointChange(index, "longitude", e.target.value)}
                    style={{ width: "100%", marginBottom: "5px", padding: "5px" }}
                  />
                  <input
                    type="number"
                    placeholder="Height (m)"
                    value={wp.height}
                    onChange={(e) => handleWaypointChange(index, "height", e.target.value)}
                    style={{ width: "100%", padding: "5px" }}
                  />
                </div>
              ))}

              <button
                onClick={handleAddWaypoint}
                style={{
                  backgroundColor: "#007BFF",
                  color: "white",
                  padding: "8px 12px",
                  borderRadius: "6px",
                  border: "none",
                  cursor: "pointer",
                  marginBottom: "10px",
                }}
              >
                ➕ Add Waypoint
              </button>

              <button
                onClick={handleConfirmMission}
                style={{
                  backgroundColor: "#28a745",
                  color: "white",
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                🚀 Confirm Waypoint Mission
              </button>
            </div>
          </div>
        )}

        {/* Alerts History Button */}
        <button
          onClick={() => navigate("/alerts-history")}
          style={{
            marginLeft: "15px",
            padding: "10px 15px",
            borderRadius: "6px",
            backgroundColor: "#007BFF",
            color: "white",
            border: "none",
            cursor: "pointer",
          }}
        >
          📜 View Alert History
        </button>

        {/* Recent Alerts */}
        <div className="contact-patrol-form">
          <h3>Recent Alerts</h3>
          {alerts.length === 0 ? (
            <p>No alerts to display</p>
          ) : (
            <ul>
              {alerts.map((alert) => (
                <li
  key={alert.id}
  onClick={() => setSelectedAlert(alert)}
  style={{
    cursor: "pointer",
    backgroundColor:
      alert.type === "Cancel"
        ? "#007BFF" // blue
        : alert.type === "Drone"
        ? "#FFC107" // yellow
        : alert.type === "Panic"
        ? "#DC3545"
        : "#DC3535", // yellow

        // red (panic)
    color: "white",
    padding: "10px",
    marginBottom: "8px",
    borderRadius: "6px",
  }}
>
  {alert.message} - 📍{" "}
  {parseFloat(alert.latitude || 0).toFixed(5)},{" "}
  {parseFloat(alert.longitude || 0).toFixed(5)}
</li>

              ))}
            </ul>
          )}
        </div>
          {assignOpen && selectedAlert && (
  <div style={{
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3000
  }}>
    <div style={{ background: "#fff", padding: 20, borderRadius: 8, width: 400, maxWidth: "90%" }}>
      <h3>Assign Alert #{selectedAlert.id}</h3>

      <label style={{ display: "block", marginBottom: 8 }}>Select Patrol Unit</label>
      <select
        value={selectedPatrolName}
        onChange={(e) => setSelectedPatrolName(e.target.value)}
        style={{ width: "100%", padding: 8, marginBottom: 12 }}
      >
        <option value="">-- Choose Patrol --</option>
        {patrols.map(p => (
          <option key={p.id} value={p.fullName}>{p.fullName}</option>
        ))}
      </select>

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button onClick={() => setAssignOpen(false)}>Cancel</button>
        <button
          style={{ background: "#28a745", color: "#fff", border: "none", padding: "8px 12px", borderRadius: 6, cursor: "pointer" }}
          onClick={async () => {
            if (!selectedPatrolName) return alert("Select a patrol unit first");
            try {
              const url = `https://senu-app.azurewebsites.net/api/alerts/forward/${selectedAlert.id}?patrolUnitName=${encodeURIComponent(selectedPatrolName)}`;
              const res = await fetch(url, { method: "POST" });
              const result = await res.json();
              if (!res.ok) throw new Error(result.message || "Failed to assign");
              // Update UI locally
              setAlerts(prev => prev.map(a =>
                a.id === selectedAlert.id ? { ...a, status: "Assigned", patrolUnitName: selectedPatrolName } : a
              ));
              setAssignOpen(false);
              alert(`Assigned to ${selectedPatrolName}`);
            // 3️⃣ Notify patrol unit via SignalR
            if (connection && connection.invoke) {
              await connection.invoke("SendAlertToPatrol", selectedPatrolName, selectedAlert);
            }
            
            } catch (e) {
              alert(e.message);
            }
          }}
        >
          Assign
        </button>
      </div>
    </div>
  </div>
)}

        {/* Contact Patrol */}
        <div className="contact-patrol-form">
          <h3>Contact Patrol Unit</h3>
          <select value={selectedPatrol} onChange={(e) => setSelectedPatrol(e.target.value)}>
            <option value="">Select Patrol Unit</option>
            <option value="Patrol 1">Patrol 1</option>
            <option value="Patrol 2">Patrol 2</option>
          </select>
          <textarea placeholder="Enter your message..." value={message} onChange={(e) => setMessage(e.target.value)} />
          <button onClick={handleContactPatrol}>📨 Send</button>
        </div>

        {/* Selected Alert Modal */}
        {selectedAlert && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0,0,0,0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 2000,
            }}
          >
            <div
              className="alert-modal"
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                width: "90%",
                maxWidth: "500px",
                padding: "20px",
                position: "relative",
                boxShadow: "0 0 10px rgba(0,0,0,0.3)",
              }}
            >
              <button
                onClick={() => setSelectedAlert(null)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  color: "#007BFF",
                }}
              >
                ✖
              </button>

              <h3 style={{ textAlign: "center", marginTop: "0" }}>Alert Details</h3>
              <p>
                <strong>Status:</strong> {selectedAlert.status}
              </p>
              <p>
                <strong>Message:</strong> {selectedAlert.message}
              </p>
              <p>
                <strong>Location:</strong> {parseFloat(selectedAlert.latitude || 0)}, {parseFloat(selectedAlert.longitude || 0)}
              </p>

              {isLoaded && (
                <div style={{ height: "300px", width: "100%", marginTop: "15px" }}>
                  <GoogleMap
                    mapContainerStyle={{ height: "100%", width: "100%" }}
                    center={{
                      lat: parseFloat(selectedAlert.latitude || 0),
                      lng: parseFloat(selectedAlert.longitude || 0),
                    }}
                    zoom={15}
                  >
                    <Marker
                      position={{
                        lat: parseFloat(selectedAlert.latitude || 0),
                        lng: parseFloat(selectedAlert.longitude || 0),
                      }}
                    />
                  </GoogleMap>
                </div>
              )}

              {/* Action Buttons */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <button
                  onClick={() => { handleConfirmMission(); alert(`Deploying drone to ${selectedAlert.latitude}, ${selectedAlert.longitude}`); }}
                  style={{ flex: "1", padding: "10px", backgroundColor: "#28a745", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
                >
                  🚁 Deploy Drone
                </button>
                <button
                   onClick={async () => {
                      setAssignOpen(true);
                      try {
                        const res = await fetch("https://senu-app.azurewebsites.net/api/admins/patrols");
                        const data = await res.json();
                        setPatrols(data);
                      } catch (e) {
                        alert("Failed to load patrols");
                      }
                    }}
                  style={{ flex: "1", padding: "10px", backgroundColor: "#007bff", color: "white", border: "none", borderRadius: "6px", cursor: "pointer" }}
                  >
                  👮 Contact Patrol Unit
                </button>
                <button
                  onClick={() => alert(`Contacting user ID: ${selectedAlert.userId}`)}
                  style={{ flex: "1", padding: "10px", backgroundColor: "#ffc107", color: "black", border: "none", borderRadius: "6px", cursor: "pointer" }}
                >
                  📞 Contact User
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StationDashboard;
